import React from 'react';
import { IIconProps } from './utils';

export const People = ({
  fill = 'currentColor',
  height = 15,
  width = 15,
  ...rest
}: IIconProps) => (
  <svg fill="none" height={height} viewBox="0 0 15 15" width={width} xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path
      d="M0.742188 11.4972V13.3516C0.742188 13.7613 1.07429 14.0934 1.48396 14.0934H6.67628C7.08593 14.0934 7.41803 13.7613 7.41803 13.3516V11.4972C7.41803 9.65375 5.9236 8.1593 4.08012 8.1593C3.39393 8.1593 2.7561 8.36636 2.22571 8.72139M9.64331 12.9807V13.4753C9.64331 13.8166 9.92007 14.0934 10.2614 14.0934H13.4757C13.8172 14.0934 14.0938 13.8166 14.0938 13.4753V12.6099C14.0938 11.3809 13.0976 10.3846 11.8686 10.3846C11.6085 10.3846 11.3588 10.4292 11.1268 10.5112M6.67628 3.33786C6.67628 4.77168 5.51393 5.93402 4.08012 5.93402C2.64629 5.93402 1.48396 4.77168 1.48396 3.33786C1.48396 1.90405 2.64629 0.741699 4.08012 0.741699C5.51393 0.741699 6.67628 1.90405 6.67628 3.33786ZM13.723 6.30491C13.723 7.32907 12.8928 8.1593 11.8686 8.1593C10.8444 8.1593 10.0142 7.32907 10.0142 6.30491C10.0142 5.28074 10.8444 4.4505 11.8686 4.4505C12.8928 4.4505 13.723 5.28074 13.723 6.30491Z"
      stroke={fill}
      strokeLinecap="round"
      strokeWidth="1.48352"
    />
  </svg>
);
